import styled, { css } from 'styled-components';
import { getColor } from 'utils';

export const TeamAdminContainer = styled('div')`
    ${props => props.$onTeamAdmin && css`
        display: grid;
        grid-template-columns: 20.80375rem 1fr;
    `}

    width: 100%;
    height: 100%;
    color: ${props => getColor(props, 'onPrimary')};
    overflow-y: auto;
`;

export const TeamAdminNavPanel = styled('div')`
    width: 100%;
    height: 100%;
    padding: 3.25rem 2rem 1rem 2rem;
    border-right: 0.0625rem solid ${props => getColor(props, 'mediumGrey')};
    overflow-y: auto;
`;

export const CategoryName = styled('div')`
    color: ${props => props.$selected && getColor(props, 'accent')};
    font-family: ${props => props.theme.typography.primary.regular};
    display: grid;
    grid-template-columns: repeat(2, auto) 1fr;
    gap: 0.5rem;
    align-items: center;
    cursor: pointer;
    user-select: none;
    font-style: normal;
    font-size: 1.05rem;
    font-weight: 600;
    letter-spacing: 0.05rem;
    margin: 0;

    &:hover {
        color: ${props => getColor(props, 'accentHover')};
    }
`;

export const SectionTitleContainer = styled('div')`
  display: inline-flex;
`;

export const PanelTitle = styled('div')`
    display: inline-flex;
`;

export const MainContent = styled('div')`
  overflow-y: auto;
`;

export const CardsContainer = styled('div')`
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
  padding: ${props => props.$onTeamAdmin ? '0 2rem 1rem 2rem' : '1rem'};
`;

export const PageContent = styled('div')`
    width: 100%;
`;

export const TeamListContainer = styled('div')`
  position: relative;
  width: 15rem;
  padding: 0 1rem;
`;

export const SortContainer = styled('div')`
    width: fit-content;
    margin-right: 0;
    margin-left: auto;
    min-width: 15rem;
`;
